import { useIntl } from "react-intl"
import {DocumentMissing} from 'grommet-icons'
import StatusInfo from "../StatusInfo"

export default function ApiError() {
  const intl = useIntl()

  return (
    <StatusInfo
      text={intl.formatMessage({ id: 'status.apiError.text' })}
      textColor="status-warning"
      icon={
        <DocumentMissing color="status-warning" size="large" a11yTitle={intl.formatMessage({id: 'status.apiError.iconTitle'})} />
      }
      secondaryText={
        intl.formatMessage(
          {id: 'status.apiError.secondary' },
          {
            email: intl.formatMessage({id: 'common.customerServiceEmail'}),
            phoneNumber: intl.formatMessage({id: 'common.customerServicePhoneNumber'})
          })
      }
    />
  )
}
